import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CareerPath } from '../models/career-path';
import { map, Observable } from 'rxjs';
import { assignmentsPerLeader } from '../models/AssignmentsPerLeader';

@Injectable({
  providedIn: 'root',
})
export class CareerPathService {
  API_URL = `${environment.apiUrl}/career-paths`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<CareerPath[]> {
    return this.http.get<CareerPath[]>(this.API_URL).pipe(
      map(careerPaths => careerPaths.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }))
      );
  }

  addCareerPath(careerPath: CareerPath): Observable<CareerPath> {
    return this.http.post<CareerPath>(this.API_URL, careerPath);
  }

  updateCareerPath(careerPath: CareerPath): Observable<CareerPath> {
    return this.http.put<CareerPath>(`${this.API_URL}/${careerPath.id}`, careerPath);
  }

  deleteCareerPath(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }

  searchLeadersWithCriteria(practice?: string, cluster?: string, leaderName?: string): Observable<assignmentsPerLeader[]> {
    let params = new HttpParams();

    if (practice) {
      params = params.set('practice', practice);
    }
    if (cluster) {
      params = params.set('cluster', cluster);
    }
    if (leaderName) {
      params = params.set('leaderName', leaderName);
    }

    return this.http.get<assignmentsPerLeader[]>(
      `${this.API_URL}/dashboard/leader/search-with-criteria`,
      { params }
    );
  }

  getPractices(): Observable<string[]> {
    return this.http.get<string[]>(`${this.API_URL}/practices`);
  }
}
